import { IThunkActionCreator } from '../../index';
import { getUserBasedSimilarOffers } from '../../../api/similar';
import { similarOffersReceived } from './similarOffersReceived';

export function requestUserBasedSimilarOffers(offerId: number, publishedUserId: number): IThunkActionCreator {
  return (dispatch, getState, context) => {
    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getUserBasedSimilarOffers(context.httpApi, { cianOfferId: offerId, publishedUserId }).then(res => {
      if (res.statusCode === 200) {
        dispatch(similarOffersReceived(res.response, 'userBased'));
      }
    });
  };
}
